var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c(
      "div",
      {
        staticClass: "main-header",
        class: { "main-header_fixed": _vm.isHeaderFixed }
      },
      [
        _c(
          "router-link",
          { staticClass: "main-header_logo", attrs: { to: "/index" } },
          [
            _c("img", { attrs: { src: _vm.logo, alt: "RICE" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.webConfig.project.name))])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main-header_nav" },
          [
            _vm._l(_vm.webConfig.headNav, function(el, index) {
              return _c(
                "router-link",
                {
                  key: index,
                  attrs: { to: el.path, "active-class": "active" }
                },
                [_vm._v(_vm._s(el.name))]
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "version-wrap" }, [
              _vm._v("v" + _vm._s(_vm.version))
            ])
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.isHeaderFixed
      ? _c("div", { staticStyle: { height: "65px" } })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-326fd38e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-326fd38e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./examples/components/Header.vue
// module id = null
// module chunks = 